import { createContext } from "react";
export var UserContext = createContext(null);
export var blankCreds = {
    username: "",
    password: "",
};
var UserAttribute = /** @class */ (function () {
    function UserAttribute(_b) {
        var Name = _b.Name, Value = _b.Value;
        this.Name = Name;
        this.Value = Value;
    }
    return UserAttribute;
}());
export { UserAttribute };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci5qc3giLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1c2VyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBSXRDLE1BQU0sQ0FBQyxJQUFNLFdBQVcsR0FBRyxhQUFhLENBQWtCLElBQUksQ0FBQyxDQUFDO0FBRWhFLE1BQU0sQ0FBQyxJQUFNLFVBQVUsR0FBVztJQUNoQyxRQUFRLEVBQUUsRUFBRTtJQUNaLFFBQVEsRUFBRSxFQUFFO0NBQ2IsQ0FBQztBQWNGO0lBSUUsdUJBQVksRUFBZ0Q7WUFBOUMsSUFBSSxVQUFBLEVBQUUsS0FBSyxXQUFBO1FBQ3ZCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBQ2pCLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO0lBQ3JCLENBQUM7SUFDSCxvQkFBQztBQUFELENBQUMsQUFSRCxJQVFDIn0=